import { useForm } from "react-hook-form";
import { useRecoilState } from "recoil";
import { writingDetailInfoAtom } from "./Atom/writingDetailInfoAtom";
import { formFlowAtom } from "./Atom/formFlowAtom";
import axios from "axios";

interface SelectAgeFormType {
  age: number;
}

const SelectAgeForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SelectAgeFormType>({
    defaultValues: {
      age: 0,
    },
  });

  const [detailInfo, setDetailInfo] = useRecoilState(writingDetailInfoAtom);
  const [flow, setFlow] = useRecoilState(formFlowAtom);

  const API_ENDPOINT = "https://your-api-endpoint.com";

  const sendGenreAgeInfo = async (
    genre: string,
    detailedGenre: string,
    age: number
  ) => {
    try {
      const data = {
        genre,
        detailedGenre,
        age,
      };

      const response = await axios.post(`${API_ENDPOINT}`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error sending genre age info:", error);
      throw error;
    }
  };

  const onValid = async (data: SelectAgeFormType) => {
    console.log("Selected Age:", data.age);

    // const suggestedThemes = await sendGenreAgeInfo(
    //   detailInfo.genre,
    //   detailInfo.detailedGenre,
    //   data.age
    // );

    setDetailInfo((prev) => ({
      ...prev,
      age: data.age,
      //   suggestedThemes,
    }));

    setFlow(4);
  };

  const onInvalid = (errors: any) => {
    console.log("Errors:", errors);
  };

  return (
    <div>
      <div className="text-xl font-bold mb-4">연령을 선택하세요</div>
      <form onSubmit={handleSubmit(onValid, onInvalid)}>
        <div className="mb-4">
          <label htmlFor="age" className="block text-gray-500 font-medium">
            연령
          </label>
          <select
            id="age"
            {...register("age", {
              required: "연령을 선택해주세요!",
              validate: (value) => value !== 0 || "유효한 연령을 선택해주세요!", // 0일 경우 에러 발생
            })}
            className="block w-full mt-2 p-2 border border-gray-300 dark:bg-slate-600 rounded-lg"
          >
            <option value="">-- 연령을 선택하세요 --</option>
            <option value={7}>미취학 아동</option>
            <option value={8}>초등 1학년</option>
            <option value={9}>초등 2학년</option>
            <option value={10}>초등 3학년</option>
            <option value={11}>초등 4학년</option>
            <option value={12}>초등 5학년</option>
            <option value={13}>초등 6학년</option>
            <option value={14}>중등 1학년</option>
            <option value={15}>중등 2학년</option>
            <option value={16}>증등 3학년</option>
            <option value={17}>고등 1학년</option>
            <option value={18}>고등 2학년</option>
            <option value={19}>고등 3학년</option>
            <option value={20}>성인</option>
          </select>
          {errors.age && (
            <p className="text-red-500 mt-2">{errors.age.message}</p>
          )}
        </div>

        <button
          type="submit"
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          다음
        </button>
      </form>
    </div>
  );
};

export default SelectAgeForm;
